import { render, staticRenderFns } from "./FreezeDetail.vue?vue&type=template&id=8b203cca&scoped=true"
import script from "./FreezeDetail.vue?vue&type=script&lang=js"
export * from "./FreezeDetail.vue?vue&type=script&lang=js"
import style0 from "./FreezeDetail.vue?vue&type=style&index=0&id=8b203cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b203cca",
  null
  
)

export default component.exports